export default {
  bind(el, binding) {
    el.addEventListener('input', e => {
      const nLimit = binding.value
      const $target = el.querySelector('input') ? el.querySelector('input') : el.querySelector('textarea')
      if ($target && nLimit) {
        if ($target.value.length >= nLimit) {
          setTimeout(() => {
            $target.value = $target.value.slice(0, nLimit)
            const evt = document.createEvent('HTMLEvents')
            // 初始化
            evt.initEvent('input', false, false)
            $target.dispatchEvent(evt)
          }, 100)
        }
      }
    }, false)
  }
}
